import React from "react";
import styles from "../../static/css/pages.module.css";
import Title from "../../components/title/title";
import RegisterIncomeForm from "./form";
import ieSvg from "../../components/icons/ieSvg";

class RegisterIncome extends React.Component {

  componentDidMount() {
    ieSvg();
    document.title = "Зарегистрировать доход | Самозанятые";
  }

  render() {
    return (
      <div className={styles.content}>
        <div className="l-grid_pt-8 mobile_l-grid">
          <div className="l-grid__item_1"></div>
          <div className="l-grid__item_6 mobile_l-grid__item_10">
            <Title icon="icon_menu-operations" title="Зарегистрировать доход"/>
            <div className={styles.article}>
              Заполните форму для регистрации вашего дохода в качестве самозанятого.
            </div>
            <RegisterIncomeForm />
          </div>
        </div>
      </div>
    )
  }
}

export default RegisterIncome;